import axios from "axios";
import { BACKEND } from "../config/configEnvs";
import { toast } from "react-toastify";

const HandleUpdateSelectSelf = async (field, newValue, targetID, route, setElement = null) => {
  try {
    
    await axios.put(`${BACKEND}/api/${route}/${targetID}`, {
      [field]: newValue,
    });

    if (setElement) {
      setElement((prev) => ({
        ...prev,
        [field]: newValue,
      }));
    }
    
  } catch (e) {
    toast.error("Error al actualizar el dato: " + e);
  }
}

export default HandleUpdateSelectSelf